export const HR_EXPERT_HELP_PANEL = {
    TITLE: 'Get help from an HR Expert',
    BODY: 'We know this topic is complicated, and our certified Experts are here to help.',
    SUBMIT_LINK_TEXT: 'Contact an HR Expert',
    DEFAULT_PHONE: '(877) 800-6675',
    QUERY_PARAM_SOURCE: 'compliance_expert_panel',
    TOP_NAV_SOURCE: 'top_nav',
};
